export const formatPrice = (price: number) => {
    const roundedPrice = Math.round(price);
    // because de-DE adds dots as separators
    return roundedPrice.toLocaleString('de-DE', {});
}